'use strict';

function getUrlSlug(value) {
  return value
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}

function getCategoryIdFromSlug({ I18n, categoryData, categorySlug }) {
  const { id: result } =
    categoryData.find(({ id }) => {
      const name = I18n.t(`modules.category.Name.${id}`);
      return getUrlSlug(name) === categorySlug;
    }) || {};

  return result;
}

function getSubCategoryIds({ parentId, categoryData }) {
  const subCategories = [];

  if (parentId) {
    categoryData.filter(category => {
      if (category.parentId === parentId) {
        subCategories.push(category.id);
      }
    });
  }

  return subCategories.length ? subCategories.join(',') : null;
}

function getUrl(base, params) {
  let url = base;

  if (params && params.length) {
    url += `?${params.join('&')}`;
  }

  return url;
}

function getCategoryLink({ categoryName, routes }) {
  const categorySlug = getUrlSlug(categoryName);
  return {
    href: routes.category.show.replace('{categorySlug}', categorySlug),
    'data-bhc': `category:${categorySlug}`,
  };
}

function getCurrentThemedPageSlug(themes) {
  if (!themes) {
    return null;
  }

  const now = Date.now();
  const theme = themes.filter(
    ({ startDate, endDate }) =>
      new Date(startDate) < now && new Date(endDate) > now
  );

  return theme[0] ? { slug: theme[0].slug, title: theme[0].title } : null;
}

function getButtonUrl({ routes, merchantSlug, destination }) {
  if (merchantSlug && routes && routes.merchant && routes.merchant.show) {
    return routes.merchant.show.replace('{merchantSlug}', merchantSlug);
  }
  return destination;
}

function getRedirectUrl({ routes, offerData, offerId, utmMedium }) {
  if (offerData.offerType === 'OnlineCode') {
    const merchantRoute = routes.merchant.show.replace(
      '{merchantSlug}',
      offerData.merchant.merchantSlug
    );

    const params = [`did=${offerId}`];

    if (utmMedium) {
      params.push(`utm_medium=${utmMedium}`);
    }

    return getUrl(merchantRoute, params);
  }

  return routes.redirect.offers.replace('{offerId}', offerId);
}

function getReferralSource(ppcLandingPage, utmMedium) {
  if (ppcLandingPage) {
    return 'ppc';
  }

  if (utmMedium === 'email') {
    return 'email';
  }

  return '';
}

function isChromeExtensionSlug(slug) {
  if (slug && slug.toLowerCase() === 'coupons-for-merchant') {
    return true;
  }

  return false;
}

function isTermsAndConditions(slug) {
  if (slug && slug.toLowerCase() === 'advertiser-terms') {
    return true;
  }

  return false;
}

module.exports = {
  getUrlSlug,
  getCategoryIdFromSlug,
  getSubCategoryIds,
  getUrl,
  getCategoryLink,
  getCurrentThemedPageSlug,
  getButtonUrl,
  getRedirectUrl,
  getReferralSource,
  isChromeExtensionSlug,
  isTermsAndConditions,
};
